export const store = {
  state: {
    tableHeight: 'auto',
    showMore: true
  },
  UPDATE_TABLE_HEIGHT() {
    this.state.tableHeight = computedTableHeight();
  },
  TOGGLE_SHOW_MORE(showMore) {
    this.state.showMore = showMore;
    setTimeout(() => {
      this.state.tableHeight = computedTableHeight();
    }, 350);
  }
};

function computedTableHeight() {
  let documentHeight = document.body.clientHeight;

  let appHeader = document.querySelector('.app-header');
  let rtHeader = document.querySelector('.rt-header');
  let pagination = document.querySelector('.rt-table-pagination');

  let appHeaderHeight = appHeader ? appHeader.clientHeight : 0;
  let rtHeaderHeight = rtHeader ? rtHeader.clientHeight : 0;
  let paginationHeight = pagination ? pagination.clientHeight : 0;
  return documentHeight - appHeaderHeight - rtHeaderHeight - paginationHeight;
}

window.onresize = () => {
  store.UPDATE_TABLE_HEIGHT();
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/table/store.js